// extracted by mini-css-extract-plugin
module.exports = {"root":"modal-header-brand_root__LTNwE"};